import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  IMAGE: `${cleanedFilename(__filename)}-image`,
  HEADING: `${cleanedFilename(__filename)}-heading`,
};
